// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sW5X","col":"styles_col__35NZy"};